module.exports = "data:application/font-woff;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI5MTYzYjFhYjcwNmQ5NWI4MDViYzc5OTg0NTI0YzVhZS5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 1060
// module chunks = 1